import { AgxBadge, BadgeColor } from '@urbanx/agx.ui-components2';
import { MarketingPackageModelCampaignFlowDisplayStatus } from '@urbanx/agx.marketing.client';
import { CampaignAdminModelMarketingStatus } from '@urbanx/agx.campaigns.client';

type CampaignFlowStatus =
  | MarketingPackageModelCampaignFlowDisplayStatus
  | CampaignAdminModelMarketingStatus;

interface StatusConfig {
  text: string;
  badgeColor: BadgeColor;
}

export const getStatusConfig = (status: CampaignFlowStatus | undefined): StatusConfig | null => {
  switch (status) {
    case MarketingPackageModelCampaignFlowDisplayStatus.Draft:
      return { text: 'Draft', badgeColor: 'yellow' };
    case MarketingPackageModelCampaignFlowDisplayStatus.AwaitingFunds:
      return { text: 'Awaiting Funds', badgeColor: 'purple' };
    case MarketingPackageModelCampaignFlowDisplayStatus.PayLaterApplicationSigned:
      return { text: 'Pay Later Application Signed', badgeColor: 'yellow' };
    case MarketingPackageModelCampaignFlowDisplayStatus.Paid:
      return { text: 'Paid', badgeColor: 'green' };
    case MarketingPackageModelCampaignFlowDisplayStatus.Cancelled:
      return { text: 'Cancelled', badgeColor: 'lightgrey' };
    case MarketingPackageModelCampaignFlowDisplayStatus.PendingSettlement:
      return { text: 'Pending Settlement', badgeColor: 'blue' };
    case MarketingPackageModelCampaignFlowDisplayStatus.Complete:
      return { text: 'Paid', badgeColor: 'green' };
    case MarketingPackageModelCampaignFlowDisplayStatus.Withdrawn:
      return { text: 'Withdrawn', badgeColor: 'red' };
    case MarketingPackageModelCampaignFlowDisplayStatus.PayLaterDeclined:
      return { text: 'Pay Later Declined', badgeColor: 'red' };
    default:
      return null;
  }
};

interface CampaignFlowStatusBadgeProps {
  status?: CampaignFlowStatus;
}

const CampaignFlowStatusBadge = ({ status }: CampaignFlowStatusBadgeProps) => {
  if (status === undefined || status === null) return <></>;

  const config = getStatusConfig(status);
  if (!config) return <></>;

  return <AgxBadge text={config.text} colour={config.badgeColor} type="colourfill" size="md" />;
};

export default CampaignFlowStatusBadge;
